export default "__VITE_ASSET__BVDAhW3d__"